import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Modules} from '@core/enums/modules.enum';
import {Entities} from '@core/components/entities.enum';
import {NgxPermissionsService} from 'ngx-permissions';
import arrayPath from '@shared/utils/array-path/array-path.utils';
import {Permissions} from '@core/enums/permissions.enum';

@Injectable({providedIn: 'root'})
export class ConnectRedirectGuard {
    constructor(
        private router: Router,
        private ngxPermissionsService: NgxPermissionsService,
    ) {
    }

    public canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): UrlTree {
        const hasJuniorPermission = this.ngxPermissionsService.getPermission(
            arrayPath([Modules.ConnectMonitoring, Permissions.Junior, Permissions.Show])
        );

        const hasDashboardPermission = this.ngxPermissionsService.getPermission(
            arrayPath([Modules.ConnectMonitoring, Permissions.Dashboard, Permissions.Show])
        );

        if (hasJuniorPermission) {
            return this.router.createUrlTree([Modules.Connect, Entities.Juniors]);
        }

        if (hasDashboardPermission) {
            return this.router.createUrlTree([Modules.Connect, Entities.Dashboards]);
        }

        return this.router.createUrlTree([Modules.Connect, Entities.Home]);
    }
}
